import { motion } from "framer-motion"
import { useLanguageStore } from "../../state-management/languageStore"

const CookieToggle = ({ hasAllowedCookies, setShowCookiePrompt }) => {
    const t = useLanguageStore((state) => state.translate)
    return (
        <motion.div key={1} exit={{ opacity: 0 }} transition={{ duration: 2 }}>
            <h3 className="fg-color-1 font-semibold mb-2">
                {t("cookies.title")}
            </h3>
            <p className="text-xs mb-3 fg-color-3 italic">
                {t("cookies.description")}
            </p>
            <button
                className={`border ${hasAllowedCookies ? "border-green-300" : "border-neutral-400 dark:border-neutral-700"}
                w-20 h-8 bg-color-3 rounded-full overflow-hidden relative`}
                onClick={() => setShowCookiePrompt(true)}
            >
                <div
                    className={` transition-all bg-gradient-to-br ${hasAllowedCookies ? "from-green-300 to-green-400" : "from-red-300 to-red-400"} w-full h-full`}
                ></div>
                <motion.div
                    initial={{ x: hasAllowedCookies ? 48 : 0 }}
                    animate={{ x: hasAllowedCookies ? 48 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="h-[calc(100%-.5rem)] aspect-square rounded-full grid place-items-center absolute top-1 left-1"
                >
                    <div className="h-full w-full relative">
                        <motion.div
                            style={{ gridRow: 1, gridColumn: 1 }}
                            animate={{
                                rotate: hasAllowedCookies ? 0 : -90,
                            }}
                            transition={{ duration: 0.3 }}
                            className="h-full w-full absolute flex items-center justify-center"
                        >
                            <svg
                                height={"100%"}
                                viewBox="0 0 21 21"
                                className="fill-amber-600 rounded-full"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15.0775 8.536C15.3329 8.7915 15.6361 8.99418 15.9698 9.13246C16.3036 9.27074 16.6613 9.34191 17.0225 9.34191C17.3838 9.34191 17.7415 9.27074 18.0752 9.13246C18.4089 8.99418 18.7121 8.7915 18.9675 8.536C19.0945 8.408 19.3295 8.46 19.3605 8.638C19.704 10.5759 19.4205 12.5728 18.5512 14.3384C17.6818 16.1041 16.272 17.5465 14.5266 18.4558C12.7813 19.3652 10.7913 19.6942 8.84614 19.395C6.90095 19.0957 5.10189 18.1839 3.71053 16.792C2.31862 15.4006 1.40678 13.6016 1.10755 11.6564C0.808322 9.7112 1.13731 7.72127 2.04669 5.9759C2.95607 4.23052 4.39843 2.82069 6.16409 1.95135C7.92975 1.08201 9.92667 0.798488 11.8645 1.142C12.0425 1.173 12.0945 1.408 11.9665 1.536C11.5584 1.9441 11.289 2.47025 11.1966 3.03994C11.1041 3.60962 11.1932 4.19397 11.4513 4.71021C11.7093 5.22644 12.1233 5.6484 12.6344 5.91632C13.1456 6.18424 13.7282 6.28453 14.2995 6.203C14.2392 6.62558 14.2782 7.05638 14.4132 7.46131C14.5482 7.86625 14.7757 8.23418 15.0775 8.536Z"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M6.50195 14.751C7.19231 14.751 7.75195 14.1913 7.75195 13.501C7.75195 12.8106 7.19231 12.251 6.50195 12.251C5.8116 12.251 5.25195 12.8106 5.25195 13.501C5.25195 14.1913 5.8116 14.751 6.50195 14.751Z"
                                    fill="black"
                                />
                                <path
                                    d="M5.50195 8.75098C6.19231 8.75098 6.75195 8.19133 6.75195 7.50098C6.75195 6.81062 6.19231 6.25098 5.50195 6.25098C4.8116 6.25098 4.25195 6.81062 4.25195 7.50098C4.25195 8.19133 4.8116 8.75098 5.50195 8.75098Z"
                                    fill="black"
                                />
                                <path
                                    d="M10.502 11.751C11.1923 11.751 11.752 11.1913 11.752 10.501C11.752 9.81062 11.1923 9.25098 10.502 9.25098C9.8116 9.25098 9.25195 9.81062 9.25195 10.501C9.25195 11.1913 9.8116 11.751 10.502 11.751Z"
                                    fill="black"
                                />
                                <path
                                    d="M13.502 15.751C14.1923 15.751 14.752 15.1913 14.752 14.501C14.752 13.8106 14.1923 13.251 13.502 13.251C12.8116 13.251 12.252 13.8106 12.252 14.501C12.252 15.1913 12.8116 15.751 13.502 15.751Z"
                                    fill="black"
                                />
                            </svg>
                        </motion.div>
                    </div>
                </motion.div>
            </button>
        </motion.div>
    )
}

export default CookieToggle
